import React, {useEffect, useState} from 'react'
import {Link} from 'gatsby'
import subPageNavStyle from "../components/css/subPageNav.module.scss";

import arrow from '../assets/triangle.svg';

export default function({title,children, linksData, linkLabel, type}){
    const [show, setShow] = useState(0)
    linkLabel = linkLabel || "Other Course Types";
console.log("subpage nav", linksData)
    const showMenu = function(e){
        document.querySelector(".subnav ul").style.display = (document.querySelector(".subnav ul").style.display=="block") ? "none" : "block";
    }

    if (type=="subpage"){
        return (
            <div className={subPageNavStyle.navbox + " " + subPageNavStyle.nopad + " "  +subPageNavStyle.subpageheader}>
                <h1>{title}</h1>
                <nav className="subnav">
                    <div onClick={e=>showMenu(e)}>
                        <h2>{linkLabel}</h2>
                        <span className={"arrow "}><img src={arrow} alt="Down Arrow"/></span>
                    </div>
                    <ul>
                        {
                            linksData.map(link=>{
                                return <li><Link to={link.slug}>{link.name}</Link></li>
                            })
                        }                    
                    </ul>
                </nav>
            </div>
        )
    } else {
        return (
            <div className={subPageNavStyle.navbox + " " + subPageNavStyle.nopad}>
                <div className={subPageNavStyle.content}>
                    <h1>{title}</h1>
                    {children}
                </div>
                <nav className="subnav">
                    <div onClick={e=>showMenu()}>
                        <h2>{linkLabel}</h2>
                        <span className={"arrow "}><img src={arrow} alt="Down Arrow"/></span>
                    </div>
                    <ul>
                        {
                            linksData.map(link=>{
                                return <li><Link to={link.slug}>{link.name}</Link></li>
                            })
                        }                    
                    </ul>
                </nav>
            </div>
        )
    }
}